<template>
	<div class="dataTables_empty text-center"> 
		<span class="noData-img my-3">
		   <img src="../../../../static/website/images/no-data.png" alt="Icon">	
		</span>
		<p>No data available</p>
  	</div>
</template>
<script>
export default {
    name:'no-data',
}
</script>


// WEBPACK FOOTER //
// src/components/website/shared/no-data.vue